import { ClientEvents, MealPlanAnalyticsLocation } from 'common/events/ClientEvents';
import { QueryParams } from 'common/urls/QueryParams';
import { Slugs } from 'common/urls/Slugs';
import { useRouteMatch } from 'react-router';
import { useHistory } from 'src/shared/hooks/useHistory';
import { useTracker } from 'src/shared/hooks/useTracker';
import { Routes } from 'src/shared/Routes';
import { getSlug, getSluggedPath } from 'src/shared/utils/RouteUtilities';
import { StringParam, useQueryParam } from 'use-query-params';

interface useShefProfileNavArgs {
  analyticsLocation?: MealPlanAnalyticsLocation;
}

export const useShefProfileNav = (args: useShefProfileNavArgs = {}) => {
  const tracker = useTracker();
  const history = useHistory();
  const { analyticsLocation } = args;

  /**
   * Get the shefId from the route.
   * Explore uses slug in URL, whereas MealPlan checkout/edit pages use query param.
   */
  const match = useRouteMatch();
  const shefIdFromSlug = getSlug(match, Slugs.SHEF_ID);
  const [shefProfileId, setShefProfileId] = useQueryParam(QueryParams.SHEF, StringParam);

  const hasShefIdInRoute = !!(shefProfileId ?? shefIdFromSlug);
  const isShefProfileViewOpen = hasShefIdInRoute;

  const closeShefProfileView = () => {
    setShefProfileId(undefined);
  };

  const openShefProfileView = (shefId: string) => {
    tracker.track(ClientEvents.SHEF_MENU_CLICK, { shefId, location: analyticsLocation });
    setShefProfileId(shefId);
  };

  const navigateToShefMenu = (shefId: string) => {
    const routeForShefMenu = getSluggedPath(Routes.CONSUMER_ORDER_WSS_SHEF, [{ slug: Slugs.SHEF_ID, value: shefId }]);
    tracker.track(ClientEvents.SHEF_MENU_CLICK, { shefId, location: analyticsLocation });
    history.push(routeForShefMenu);
  };

  return {
    isShefProfileViewOpen,
    shefProfileId,
    closeShefProfileView,
    openShefProfileView,
    navigateToShefMenu,
  };
};
